<template>
  <div class="bg-secondary-3 px-4 p-4">
    <div class="row">
      <div class="col-12 mb-2 ">
        <icon-view
          :has-border="false"
          icon="fas fa-calendar-edit text-orange"
          icon-size="17px"
          :title="title"
          variant="custom-icon-view"
          icon-background="white"
        />
      </div>
    </div>
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-date-picker
              v-model="model.date"
              required
              :label="label"
              placeholder="DD/MM/YYYY"
              class="cd"
              :max-date="new Date()"
              :min-date="minDate"
              :error="errors[0]"
              :custom-error-msg="'La fecha es requerida'"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('cancel')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import CustomDatePicker from 'custom-date-picker';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import moment from 'moment';

export default {
  name: 'DocumentDate',
  components: {
    ActionButton,
    IconView,
    CustomDatePicker,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    recommendation: {
      type: Object,
      default: () => null,
    },
    isCSEE: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title() {
      return this.isCSEE
        ? 'Documentación de Fecha entrega CSEE'
        : 'Documentación de Fecha entrega Escuela';
    },
    label() {
      return this.isCSEE
        ? 'Fecha en que se recibió en el CSEE:'
        : 'Fecha en que se recibió en la Escuela:';
    },
    minDate() {
      return this.isCSEE && this.recommendation?.poDate
        ? moment(this.recommendation.poDate)
            .add(-1, 'days')
            .toDate()
        : !this.isCSEE && this.recommendation?.receivedCseedate
        ? moment(this.recommendation.receivedCseedate)
            .add(-1, 'days')
            .toDate()
        : null;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }
      this.$emit('save');
    },
  },
};
</script>
<style lang="scss"></style>
